import { RestResponse } from "@/business/shared/commons/rest/RestResponse";
import { restClient } from "@/business/shared/commons/rest/restClient";
import { getEnvVariable } from "@/business/shared/commons/envUtils/getEnvVariable";
import { UserEditRequest } from "../../domain/user";
import { editUserUrl } from "../constants/urls";
import { convertFormData } from "@/business/shared/commons/rest/convertToFormData";
import { DaccachErrorActions } from "@/business/shared/commons/DaccachError";

export const editUserService = {
  async execute(
    token: string,
    editUserRequest: UserEditRequest
  ): Promise<void> {
    const url = getEnvVariable
      .execute("VUE_APP_DACCACH_URL")
      .concat(editUserUrl);

    const headers = {
      "web-token": token,
      Accept: "application/json",
    };

    const formData = convertFormData(editUserRequest);

    const response: RestResponse = await restClient().sendRequest(
      url,
      "POST",
      formData,
      headers
    );

    if (!response.isSuccess) {
      const errorMessage =
        response.statusCode == 422
          ? DaccachErrorActions().extractFormError(response.content)
          : response.content;
      throw DaccachErrorActions().createError(errorMessage);
    }
  },
};
